const getListingScore = /* GraphQL */ `
  query GetListingScore($skuVariantNumber: String!) {
    listingScore(skuVariantNumber: $skuVariantNumber) {
      skuVariantNumber
      brandId
      score
      overallScore
      scoreBand
      calculatedUtc
      categoryScores {
        categoryName
        score
        scoreBand
      }
      failedRules {
        ruleId
        passed
      }
      recommendations {
        category
        recommendation
        potentialScoreLift
      }
    }
  }
`

export default getListingScore
